class RestAPI {
    constructor(baseUrl = '') {
        this.baseUrl = baseUrl || '';
    }

    /**
     * Generic fetch method with error handling
     */
    async _fetch(endpoint, options = {}) {
        try {
            const response = await fetch(`${this.baseUrl}${endpoint}`, {
                headers: {
                    'Content-Type': 'application/json',
                    ...options.headers
                },
                ...options
            });

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            return await response.json();
        } catch (error) {
            console.error(`API Error at ${endpoint}:`, error);
            throw error;
        }
    }

    /**
     * Load comments for a specific work
     */
    async loadComment(work_id) {
        return await this._fetch(`/wp-json/eSantier/v1/comment?work_id=${work_id}`);
    }

    /**
     * Load worked days for a worker and year
     */
    async loadWorkedDays(worker_id, year) {
        return await this._fetch(`/wp-json/eSantier/v1/worked_days?worker_id=${worker_id}&year=${year}`);
    }

    /**
     * Post a new comment
     */
    async postComment(commentData) {
        return await this._fetch('/wp-json/eSantier/v1/comment', {
            method: 'POST',
            body: JSON.stringify(commentData)
        });
    }

    /**
     * Update a comment
     */
    async updateComment(commentId, commentData) {
        return await this._fetch(`/wp-json/eSantier/v1/comment/${commentId}`, {
            method: 'PUT',
            body: JSON.stringify(commentData)
        });
    }

    /**
     * Delete a comment
     */
    async deleteComment(commentId) {
        return await this._fetch(`/wp-json/eSantier/v1/comment/${commentId}`, {
            method: 'DELETE'
        });
    }

    /**
     * Generic GET request
     */
    async get(endpoint, params = {}) {
        const queryString = Object.keys(params)
            .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`)
            .join('&');

        const url = queryString ? `${endpoint}?${queryString}` : endpoint;
        return await this._fetch(url);
    }

    /**
     * Generic POST request
     */
    async post(endpoint, data) {
        return await this._fetch(endpoint, {
            method: 'POST',
            body: JSON.stringify(data)
        });
    }

    /**
     * Generic PUT request
     */
    async put(endpoint, data) {
        return await this._fetch(endpoint, {
            method: 'PUT',
            body: JSON.stringify(data)
        });
    }

    /**
     * Generic DELETE request
     */
    async delete(endpoint) {
        return await this._fetch(endpoint, {
            method: 'DELETE'
        });
    }
}

const Api = new RestAPI();
export default Api;

// Exemplu de utilizare:
/*
// Initializare
const api = new RestAPI(); // Poți pasa un baseUrl dacă este necesar

// Utilizare în codul tău existent
async function loadWorkData(rowData) {
    try {
        const commentResponse = await api.loadComments(rowData.id);
        rowData.comment = commentResponse;

        // Sau pentru worked days
        const workedDays = await api.loadWorkedDays(worker_id, year);

    } catch (error) {
        console.error('Error loading data:', error);
    }
}

// Utilizare generică
async function exampleUsage() {
    try {
        // Load comments
        const comments = await api.loadComments(123);

        // Load worked days
        const workedDays = await api.loadWorkedDays(456, 2024);

        // Post new comment
        const newComment = await api.postComment({
            work_id: 123,
            content: 'Acesta este un comentariu nou'
        });

    } catch (error) {
        // Gestionează erorile într-un singur loc
        console.error('API operation failed:', error);
    }
}
*/

export async function ApiLoadComments(work_id, containerId) {
    fetch(`/wp-json/eSantier/v1/comment?work_id=${work_id}`)
        .then(response => {
            if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
            return response.json();
        })
        .then(comments => { return comments; })
        .catch(error => { return error; });
}